
import React from "react";
import ScoreCardSystemRouter from "./../systems/cuadro_mando/routers/CatalogCMIRoutes";
import CatalogAdminEgresadosRoutes from "./../systems/egresados/routers/AdministrativosRoutes";
//id => Correspondiente al nombre del componente en BD
//Component => Componente a renderizar
const CatalogRouter = [
    {
        Id: "ADMIN_AREAS",
        Component: React.lazy(() => import("./../pages/Areas/Areas")),
    },
    {
        Id: "ADMINISTRADOR_DE_AVISOS",
        Component: React.lazy(() => import("./../pages/Notification/Notification")),
    }, 
    ...ScoreCardSystemRouter,
    ...CatalogAdminEgresadosRoutes
];

export default CatalogRouter;